import {
  Container,
  createStyles,
  Grid,
  makeStyles,
  Paper,
  Theme,
  Tabs,
  Tab,
  Toolbar,
  fade,
  Dialog,
  InputBase,
  Button,
  SvgIcon,
  Badge,
  Box,
  Typography,
  useMediaQuery,
  Link,
} from '@material-ui/core';
import RefreshIcon from '@material-ui/icons/Refresh';
import SearchIcon from '@material-ui/icons/Search';
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';
import NotificationsIcon from '@material-ui/icons/Notifications';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import AdditionVerificationIssuesBanner from '../../components/AdditionalVerificationIssuesBanner';
import AdditionalVerificiations from '../../components/AdditionalVerifications';
import PaymentRequestList from '../../components/PaymentRequestList';
import SendPaymentRequest from '../../components/SendPaymentRequest';
import TotalAccountBalance from '../../components/TotalAccountBalance';
import TransactionReports from '../../components/TransactionReports';
import DisputeList from '../../components/DisputeList';
import TabPanel from '../../components/TabPanel';
import IssueRefundPayment from '../../components/IssueRefundPayment';
import {
  OrderDirection,
  PaymentRequestOrder,
  PaymentRequestOrderField,
  CapabilityStatus,
  PaymentRequest,
  PaymentRequestStatus,
  Dispute,
  DisputeOrderField,
  DisputeOrder,
  DocumentTokenInput,
  Payment,
  PaymentOrder,
  PaymentOrderField,
  PaymentStatus,
  RefundStatus,
} from '../../gql-types.generated';
import { checkPermission, Permission } from '../../util/RoleCheck';
import {
  selectNetworkBusy,
  selectTenantId,
  selectViewerUser,
  selectTenantAccount,
  selectDefaultCurrency,
  selectCurrentBalances,
} from '../app/AppSlice';
import { selectTenantAccountCountry } from '../merchant-onboarding/MerchantOnboardingSlice';
import {
  fetchAccountRequirements,
  refund,
  uploadDocument,
  upsertPaymentRequest,
  fetchPaymentRequestList,
  fetchDisputeList,
  remindPaymentRequest,
  upsertVerifications,
  fetchPaymentList,
} from './HomeActions';
import {
  clearDocument,
  clearPaymentRequestStatus,
  clearRefundStatus,
  selectAccountRequirements,
  selectInvoiceUniqueId,
  selectPaymentRequestConnection,
  selectDisputeConnection,
  selectPaymentRequestStatus,
  selectPaymentRequestSearch,
  captureSearchError,
  selectRefundStatus,
  selectSendPaymentRequestError,
  selectSearchError,
  selectPaymentRequests,
  selectDisputes,
  selectReminderStatus,
  clearReminderStatus,
  selectVerificationStatus,
  clearVerificationStatus,
  selectInvolvedUsers,
  fetchIsPaymentRequestFormValid,
  selectIsPaymentRequestFormValid,
  fetchIsRecipientEmailValid,
  selectIsRecipientEmailValid,
  fetchIsRecipientPhoneValid,
  selectIsRecipientPhoneValid,
  fetchIsAmountValid,
  selectIsAmountValid,
  fetchIsRefNumValid,
  selectIsRefNumValid,
  selectIsLoadingDisputes,
  selectIsLoadingPaymentRequests,
  selectRefundIdempotencyKey,
  fetchRefundIdempotencyKey,
  selectPaymentConnection,
  selectPayments,
  selectPaymentSearch,
  capturePaymentRequestSearch,
  capturePaymentSearch,
  selectIsLoadingPayments,
  fetchIsPaymentRefunded,
  fetchPaymentRefundedAmount,
  selectIsPaymentRefunded,
  selectPaymentRefundedAmount,
} from './HomeSlice';
import IssueRefund from '../../components/IssueRefund';
import { ReactComponent as RefundIcon } from '../../refund.svg';
import ChargebackReview from '../../components/ChargebackReview';
import ConcedeDispute from '../../components/ConcedeDispute';
import {
  selectConcedeExplanation,
  selectDisputedRecord,
  selectRelatedRequest,
  clearConcedeStatus,
  clearDisputeError,
  selectChallengeStatus,
  clearChallengeStatus,
} from '../challenge-dispute/ChallengeDisputeSlice';
import {
  captureConcedeExplanation,
  captureSelectedDispute,
  upsertConcedeDispute,
  captureRelatedPaymentRequest,
} from '../challenge-dispute/ChallengeDisputeActions';
import PaymentRequestDetails from '../../components/PaymentRequestDetails';
import DisputeDetails from '../../components/DisputeDetails';
import PaymentsList from '../../components/PaymentsList';
import PaymentDetails from '../../components/PaymentDetails';
import { v4 as uuid4 } from 'uuid';
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 2,
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
    contentMargin: {
      marginTop: '12px',
    },
    tabs: {
      textAlign: 'center',
      flexGrow: 1,
    },
    title: {
      flex: '1',
      textAlign: 'left',
    },
    headerSubtitle: {
      letterSpacing: 1.5,
      fontSize: 12,
      fontWeight: 'normal',
    },
    headerTitle: {
      fontWeight: 'bold',
    },
    search: {
      position: 'relative',
      paddingRight: 4,
      paddingLeft: 4,
      marginTop: 4,
      marginBottom: 2,
      borderRadius: 4,
      backgroundColor: fade(theme.palette.common.black, 0.08),
      width: '100%',
      display: 'flex',
    },
    searchOnFocus: {
      position: 'relative',
      paddingRight: 4,
      paddingLeft: 4,
      marginTop: 4,
      marginBottom: 2,
      borderRadius: 4,
      backgroundColor: fade(theme.palette.common.black, 0.08),
      width: '100%',
      display: 'flex',
      borderStyle: 'solid',
      borderColor: '#276EF1DE',
      borderWidth: '2px',
    },
    searchError: {
      position: 'relative',
      paddingRight: 4,
      paddingLeft: 4,
      marginTop: 4,
      marginBottom: 2,
      borderRadius: 4,
      backgroundColor: fade(theme.palette.common.black, 0.08),
      width: '100%',
      display: 'flex',
      borderStyle: 'solid',
      borderColor: '#FF3B30',
      borderWidth: '2px',
    },
    searchIcon: {
      width: '7%',
      color: fade(theme.palette.common.black, 0.6),
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      paddingTop: 6,
    },
    searchIconError: {
      color: '#FF3B30',
    },
    closeIcon: {
      color: fade(theme.palette.common.black, 0.6),
    },
    inputSearch: {
      width: '93%',
    },
    inputRoot: {
      color: 'inherit',
      width: '100%',
    },
    inputInput: {
      padding: theme.spacing(1, 1, 1, 2),
      transition: theme.transitions.create('width'),
      width: '100%',
    },
    selectedTab: {
      borderBottomWidth: 0,
    },
    tabRoot: {
      borderBottomWidth: 1,
      borderBottomStyle: 'solid',
      borderBottomColor: theme.palette.grey[300],
    },
    disputesBadge: {
      textAlign: 'center',
      fontSize: '0.7rem',
      borderRadius: '50%',
      height: '1.2rem',
      minWidth: '1.2rem',
      top: '50%',
      right: '-25%',
    },
    errorContent: {
      textAlign: 'left',
      fontSize: '10px',
      paddingLeft: 8,
    },
    challengeBanner: {
      minHeight: theme.spacing(8),
      backgroundColor: '#EAF9EE',
      color: 'green',
      boxShadow: '0px 3px 6px #00000012',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      [theme.breakpoints.up('lg')]: {
        margin: theme.spacing(-3, -6, 3),
        padding: theme.spacing(2),
      },
      [theme.breakpoints.down('lg')]: {
        margin: theme.spacing(-1.5, -4, 3),
        padding: theme.spacing(1),
      },
    },
  }),
);

const Home: React.FC = () => {
  const classes = useStyles();
  const tenantId = useSelector(selectTenantId);
  const user = useSelector(selectViewerUser);
  const tenantAccount = useSelector(selectTenantAccount);
  const accountRequirements = useSelector(selectAccountRequirements);
  const networkBusy = useSelector(selectNetworkBusy);
  const countryCode = useSelector(selectTenantAccountCountry);
  const invoiceStorageId = useSelector(selectInvoiceUniqueId);
  const paymentRequestQueryString = useSelector(selectPaymentRequestSearch);
  const payRequestConnection = useSelector(selectPaymentRequestConnection);
  const paymentRequests = useSelector(selectPaymentRequests);
  const disputeConnection = useSelector(selectDisputeConnection);
  const disputes = useSelector(selectDisputes);
  const defaultCurrency = useSelector(selectDefaultCurrency);
  const currentBalances = useSelector(selectCurrentBalances);
  const refundStatus = useSelector(selectRefundStatus);
  const paymentRequestStatus = useSelector(selectPaymentRequestStatus);
  const reminderStatus = useSelector(selectReminderStatus);
  const disputedRecord = useSelector(selectDisputedRecord);
  const disputeRelatedRequest = useSelector(selectRelatedRequest);
  const concedeExplanation = useSelector(selectConcedeExplanation);
  const challengeStatus = useSelector(selectChallengeStatus);
  const sendPaymentRequestError = useSelector(selectSendPaymentRequestError);
  const isPaymentRequestFormValid = useSelector(selectIsPaymentRequestFormValid);
  const isRecipientEmailValid = useSelector(selectIsRecipientEmailValid);
  const isRecipientPhoneValid = useSelector(selectIsRecipientPhoneValid);
  const isAmountValid = useSelector(selectIsAmountValid);
  const isRefNumValid = useSelector(selectIsRefNumValid);
  const isLoadingPaymentRequests = useSelector(selectIsLoadingPaymentRequests);
  const isLoadingDisputes = useSelector(selectIsLoadingDisputes);
  const searchError = useSelector(selectSearchError);
  const verificationStatus = useSelector(selectVerificationStatus);
  const involvedUsers = useSelector(selectInvolvedUsers);
  const refundIdempotencyKey = useSelector(selectRefundIdempotencyKey);
  const paymentConnection = useSelector(selectPaymentConnection);
  const payments = useSelector(selectPayments);
  const paymentQueryString = useSelector(selectPaymentSearch);
  const isLoadingPayments = useSelector(selectIsLoadingPayments);
  const isPaymentRefunded = useSelector(selectIsPaymentRefunded);
  const paymentRefundedAmount = useSelector(selectPaymentRefundedAmount);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [remindDisabled, setRemindDisabled] = useState(false);
  const [refundDialogOpen, setRefundDialogOpen] = useState(false);
  const [paymentRefundDialogOpen, setPaymentRefundDialogOpen] = useState(false);
  const [detailsDialogOpen, setDetailsDialogOpen] = useState(false);
  const [paymentDetailsDialogOpen, setPaymentDetailsDialogOpen] = useState(false);
  const [chargebackDialogOpen, setChargebackDialogOpen] = useState(false);
  const [concedeDialogOpen, setConcedeDialogOpen] = useState(false);
  const [disputeDetailsDialogOpen, setDisputeDetailsDialogOpen] = useState(false);
  const [transactionYearsDialogOpen, setTransactionYearsDialogOpen] = useState(false);
  const [selectedPaymentRequest, setSelectedPaymentRequest] = useState<PaymentRequest | undefined>();
  const [selectedPayment, setSelectedPayment] = useState<Payment | undefined>();
  const [selectedDispute, setSelectedDispute] = useState<Dispute | undefined>();
  const [displayChallengeSuccessful, setDisplayChallengeSuccessful] = useState(false);
  const [paymentRequestOrder, setPaymentRequestOrder] = useState<PaymentRequestOrder>({
    direction: OrderDirection.Desc,
    field: PaymentRequestOrderField.Timestamp,
  });
  const [disputeOrder, setDisputeOrder] = useState<DisputeOrder>({
    direction: OrderDirection.Desc,
    field: DisputeOrderField.Timestamp,
  });
  const [paymentOrder, setPaymentOrder] = useState<PaymentOrder>({
    direction: OrderDirection.Desc,
    field: PaymentOrderField.Timestamp,
  });
  const [activeViewPaymentRequestRecord, setActiveViewPaymentRequestRecord] = useState<PaymentRequest | undefined>();
  const [activeRefundPaymentRequestRecord, setActiveRefundPaymentRequestRecord] = useState<PaymentRequest | undefined>();
  const [activeViewPaymentRecord, setActiveViewPaymentRecord] = useState<Payment | undefined>();
  const [activeRefundPaymentRecord, setActiveRefundPaymentRecord] = useState<Payment | undefined>();
  const [tabValue, setTabValue] = useState(0);
  const [paymentRequestDirection, setPaymentRequestDirection] = useState<OrderDirection>(OrderDirection.Desc);
  const [disputeDirection, setDisputeDirection] = useState<OrderDirection>(OrderDirection.Desc);
  const [paymentDirection, setPaymentDirection] = useState<OrderDirection>(OrderDirection.Desc);
  const [paymentRequestField, setPaymentRequestField] = useState<PaymentRequestOrderField>(PaymentRequestOrderField.Timestamp);
  const [disputeField, setDisputeField] = useState<DisputeOrderField>(DisputeOrderField.Timestamp);
  const [paymentField, setPaymentField] = useState<PaymentOrderField>(PaymentOrderField.Timestamp);
  const [isPaymentSearchOnFocus, setIsPaymentSearchOnFocus] = useState<boolean>(false);
  const [isValidPaymentSearchString, setIsValidPaymentSearchString] = useState<boolean>(true);
  const [isPaymentSearched, setIsPaymentSearched] = useState<boolean>(false);
  const [isPaymentSearchClicked, setIsPaymentSearchClicked] = useState<boolean>(false);
  const [paymentSearchString, setPaymentSearchString] = useState<string>('');
  const [isPaymentRequestSearchOnFocus, setIsPaymentRequestSearchOnFocus] = useState<boolean>(false);
  const [isValidPaymentRequestSearchString, setIsValidPaymentRequestSearchString] = useState<boolean>(true);
  const [isPaymentRequestSearched, setIsPaymentRequestSearched] = useState<boolean>(false);
  const [isPaymentRequestSearchClicked, setIsPaymentRequestSearchClicked] = useState<boolean>(false);
  const [paymentRequestSearchString, setPaymentRequestSearchString] = useState<string>('');
  const dispatch = useDispatch();
  const history = useHistory();
  const canCreatePaymentRequest = checkPermission(Permission.PaymentRequestCreate, user?.relationship?.role);
  const paymentsEnabled =
    tenantAccount?.capabilities?.cardPayments === CapabilityStatus.Active && tenantAccount.settings?.cardPayments?.refundPolicy;

  const entityName = tenantAccount && tenantAccount.businessProfile?.name ? tenantAccount.businessProfile?.name : '';
  let disputeAlerts = '0';
  const activeDisputes =
    disputeConnection?.nodes.length === 0
      ? 0
      : disputeConnection?.nodes.filter(node => {
          const createdDate = new Date(node?.createdAt);
          const today = new Date();
          const difference = today.valueOf() - createdDate.valueOf();
          const days = difference < 0 ? -1 : Math.floor(difference / 86400000);
          return node?.status === 'AWAITING_MERCHANT_RESPONSE' && days >= 0 && days < 7;
        }).length;
  if (activeDisputes) disputeAlerts = activeDisputes >= 10 ? '9+' : activeDisputes?.toString();
  const disputesLabel = (
    <Badge
      badgeContent={disputeAlerts}
      color="error"
      overlap="circle"
      classes={{
        anchorOriginTopRightCircle: classes.disputesBadge,
      }}
    >
      <span>DISPUTES</span>
    </Badge>
  );
  const matches = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  const paymentSearchClass = isValidPaymentSearchString ? classes.searchOnFocus : classes.searchError;
  const paymentRequestSearchClass = isValidPaymentRequestSearchString ? classes.searchOnFocus : classes.searchError;
  // Infinite load page size.
  const pageSize = 25;
  // Fetch requirement data once we have tenantId
  useEffect(() => {
    if (tenantId) {
      console.log('[1] fetching more data');
      dispatch(fetchAccountRequirements());
    }
  }, [tenantId]);

  // Fetch payment requests once we have tenant id, or the order changes.
  useEffect(() => {
    if (tenantId) {
      dispatch(fetchPaymentRequestList(undefined, pageSize, paymentRequestOrder, paymentRequestQueryString));
      setSelectedPaymentRequest(undefined);
    }
  }, [paymentRequestOrder]);

  // Fetch disputes once we have tenant id
  useEffect(() => {
    if (tenantId) {
      dispatch(fetchDisputeList(undefined, pageSize, disputeOrder));
    }
  }, [disputeOrder]);

  useEffect(() => {
    if (tenantId) {
      dispatch(fetchPaymentList(undefined, pageSize, paymentOrder, paymentQueryString));
    }
  }, [paymentOrder]);

  // Update list in the active tab with the query string changes.
  useEffect(() => {
    if (tenantId) {
      if (tabValue === 0) {
        dispatch(fetchPaymentList(undefined, pageSize, paymentOrder, paymentQueryString));
      } else if (tabValue === 1) {
        dispatch(fetchPaymentRequestList(undefined, pageSize, paymentRequestOrder, paymentRequestQueryString));
      } else {
        dispatch(fetchDisputeList(undefined, pageSize, disputeOrder));
      }
    }
  }, [tenantId, paymentRequestQueryString, paymentQueryString]);

  // Display banner after successful challenge
  useEffect(() => {
    if (challengeStatus !== undefined) {
      setDisplayChallengeSuccessful(true);
      setTimeout(() => {
        setDisplayChallengeSuccessful(false);
        dispatch(clearChallengeStatus());
      }, 5000);
    }
  }, [challengeStatus]);

  // Updates the payment details modal with the newly updated record
  useEffect(() => {
    if (activeViewPaymentRequestRecord) {
      const updatedRecord = payRequestConnection?.nodes.find(item => item?.id === activeViewPaymentRequestRecord.id);
      if (updatedRecord) {
        setActiveViewPaymentRequestRecord(updatedRecord);
      }
    }
  }, [payRequestConnection]);

  useEffect(() => {
    if (activeViewPaymentRecord) {
      const updatedRecord = paymentConnection?.nodes.find(item => item?.id === activeViewPaymentRecord.id);
      if (updatedRecord) {
        setActiveViewPaymentRecord(updatedRecord);
      }
    }
  }, [paymentConnection]);

  useEffect(() => {
    if (reminderStatus !== undefined) {
      dispatch(clearReminderStatus());
      if (tenantId) {
        dispatch(fetchPaymentRequestList(undefined, pageSize, paymentRequestOrder, paymentRequestQueryString));
        setSelectedPaymentRequest(undefined);
      }
      setRemindDisabled(false);
    }
  }, [reminderStatus]);

  useEffect(() => {
    if (dialogOpen && verificationStatus && verificationStatus !== 'ERROR') {
      setDialogOpen(false);
      clearVerificationStatus();
    }
  }, [verificationStatus]);

  const clearDocumentState = () => {
    dispatch(clearDocument());
  };
  const handleUploadClick = () => {
    setDialogOpen(true);
  };
  const handlePaymentRequestFormValid = (valid: boolean) => {
    dispatch(fetchIsPaymentRequestFormValid(valid));
  };
  const handleRecipientEmailValid = (valid: boolean) => {
    dispatch(fetchIsRecipientEmailValid(valid));
  };
  const handleRecipientPhoneValid = (valid: boolean) => {
    dispatch(fetchIsRecipientPhoneValid(valid));
  };
  const handleAmountValid = (valid: boolean) => {
    dispatch(fetchIsAmountValid(valid));
  };
  const handleRefNumValid = (valid: boolean) => {
    dispatch(fetchIsRefNumValid(valid));
  };
  const handleDialogClose = () => {
    setDialogOpen(false);
  };
  const handleSubmit = (documentTokens: DocumentTokenInput[]) => {
    dispatch(upsertVerifications(documentTokens));
  };
  const handleSettingsClick = () => {
    history.push('/settings');
  };
  const requestPaymentUploadFile = (file: File) => {
    dispatch(uploadDocument(file));
  };
  const sendRefund = (paymentId: string, refundReason: string, amount?: number | null) => {
    if (tenantId) {
      if (!refundIdempotencyKey) {
        //If an idempotency key does not exist in state, we know this is a new refund
        const uid = uuid4();
        dispatch(fetchRefundIdempotencyKey(uid));
        dispatch(refund(uid, paymentId, refundReason, amount));
      } else {
        //This is a repeated refund/double click (not sure this can actually happen but its here just in case)
        dispatch(refund(refundIdempotencyKey, paymentId, refundReason, amount));
      }
    }
  };
  const clearRefundStateStatus = () => {
    dispatch(clearRefundStatus());
  };

  const requestPaymentUpsertPaymentRequest = (
    referenceId: string,
    amount: number,
    invoiceRef: string,
    emailAddress?: string,
    phoneNumber?: string,
  ) => {
    dispatch(upsertPaymentRequest(referenceId, amount, invoiceRef, emailAddress, phoneNumber));
  };

  const requestPaymentClearPaymentRequestStatus = () => {
    dispatch(clearPaymentRequestStatus());
  };

  if (networkBusy || !paymentConnection) {
    return <Paper className={classes.paper}>Loading!</Paper>;
  }

  // Payment Request functions
  const handleSearch = () => {
    if (paymentRequestSearchString.length >= 3) {
      setIsPaymentRequestSearched(true);
      dispatch(captureSearchError(undefined));
      dispatch(capturePaymentRequestSearch(paymentRequestSearchString));
    } else {
      setIsValidPaymentRequestSearchString(false);
    }
    if (isPaymentRequestSearchClicked && isValidPaymentRequestSearchString) {
      setIsPaymentRequestSearchOnFocus(false);
    }
  };

  const handlePaymentRequestSearchOnCancel = () => {
    setIsPaymentRequestSearched(false);
    setIsValidPaymentRequestSearchString(true);
    setIsPaymentRequestSearchOnFocus(false);
    setPaymentRequestSearchString('');
    dispatch(capturePaymentRequestSearch(''));
  };

  const handlePaymentRequestSearchOnChange = (searchString: string) => {
    const search = searchString.trim();
    let isValidSearch = false;
    if (search.length >= 3) {
      isValidSearch = true;
    }
    setIsValidPaymentRequestSearchString(isValidSearch);
    setPaymentRequestSearchString(search);
    setIsPaymentRequestSearched(false);
  };

  const handlePaymentRequestSearchOnBlur = () => {
    if (!isPaymentRequestSearchClicked) {
      if (!isPaymentRequestSearched) {
        if (paymentRequestQueryString && paymentRequestQueryString.length > 0) dispatch(capturePaymentRequestSearch(''));
        setPaymentRequestSearchString('');
      }
      setIsValidPaymentRequestSearchString(true);
      setIsPaymentRequestSearchOnFocus(false);
    }
    setIsPaymentRequestSearchClicked(false);
  };

  const handlePaymentRequestsReload = () => {
    if (tenantId) {
      dispatch(fetchPaymentRequestList(undefined, pageSize, paymentRequestOrder, paymentRequestQueryString));
      setSelectedPaymentRequest(undefined);
    }
  };
  const loadPaymentRequestsPage = (endEdge: string) => {
    if (tenantId) {
      dispatch(fetchPaymentRequestList(endEdge, pageSize, paymentRequestOrder, paymentRequestQueryString));
    }
  };
  const handlePaymentRequestSort = (direction: OrderDirection, fieldName: string) => {
    const field = fieldName as PaymentRequestOrderField;
    setPaymentRequestDirection(direction);
    setPaymentRequestField(field);
    setPaymentRequestOrder({ direction, field });
  };

  const handleDisputeSort = (direction: OrderDirection, fieldName: string) => {
    const field = fieldName as DisputeOrderField;
    setDisputeDirection(direction);
    setDisputeField(field);
    setDisputeOrder({ direction, field });
  };
  const handleDisputesReload = () => {
    if (tenantId) {
      dispatch(fetchDisputeList(undefined, pageSize, disputeOrder));
      setSelectedDispute(undefined);
    }
  };
  const loadDisputesPage = (endEdge: string) => {
    if (tenantId) {
      dispatch(fetchDisputeList(endEdge, pageSize, disputeOrder));
    }
  };

  const handlePaymentsReload = () => {
    if (tenantId) {
      dispatch(fetchPaymentList(undefined, pageSize, paymentOrder, paymentQueryString));
      setSelectedPayment(undefined);
    }
  };
  const handlePaymentSort = (direction: OrderDirection, fieldName: string) => {
    const field = fieldName as PaymentOrderField;
    setPaymentDirection(direction);
    setPaymentField(field);
    setPaymentOrder({ direction, field });
  };
  const loadPaymentsPage = (endEdge: string) => {
    if (tenantId) {
      dispatch(fetchPaymentList(endEdge, pageSize, paymentOrder, paymentQueryString));
    }
  };

  const handlePaymentsSearch = () => {
    if (paymentSearchString.length >= 3) {
      setIsPaymentSearched(true);
      dispatch(captureSearchError(undefined));
      dispatch(capturePaymentSearch(paymentSearchString));
    } else {
      setIsValidPaymentSearchString(false);
    }
    if (isPaymentSearchClicked && isValidPaymentSearchString) {
      setIsPaymentSearchOnFocus(false);
    }
  };

  const handlePaymentSearchOnCancel = () => {
    setIsPaymentSearched(false);
    setIsValidPaymentSearchString(true);
    setIsPaymentSearchOnFocus(false);
    setPaymentSearchString('');
    dispatch(capturePaymentSearch(''));
  };

  const handlePaymentSearchOnChange = (searchString: string) => {
    const search = searchString.trim();
    let isValidSearch = false;
    if (search.length >= 3) {
      isValidSearch = true;
    }
    setIsValidPaymentSearchString(isValidSearch);
    setPaymentSearchString(search);
    setIsPaymentSearched(false);
  };

  const handlePaymentSearchOnBlur = () => {
    if (!isPaymentSearchClicked) {
      if (!isPaymentSearched) {
        if (paymentQueryString && paymentQueryString.length > 0) dispatch(capturePaymentSearch(''));
        setPaymentSearchString('');
      }
      setIsValidPaymentSearchString(true);
      setIsPaymentSearchOnFocus(false);
    }
    setIsPaymentSearchClicked(false);
  };

  const handleActiveTabReload = () => {
    dispatch(captureSearchError(undefined));
    if (tabValue === 0) {
      handlePaymentsReload();
    } else if (tabValue === 1) {
      handlePaymentRequestsReload();
    } else {
      handleDisputesReload();
    }
  };

  const handleTabChange = (_event: unknown, newValue: number) => {
    dispatch(captureSearchError(undefined));
    setTabValue(newValue);
  };
  const handlePaymentRequestView = (record: PaymentRequest | undefined) => {
    if (record) {
      setActiveViewPaymentRequestRecord(record);
      setDetailsDialogOpen(true);
    }
  };
  const handleDetailsClose = () => {
    setDetailsDialogOpen(false);
    dispatch(clearReminderStatus());
    setRemindDisabled(false);
  };
  const handlePaymentDetailsClose = () => {
    setPaymentDetailsDialogOpen(false);
    dispatch(captureRelatedPaymentRequest(undefined));
  };

  const findRelatedPaymentRequest = (paymentRequestId: string) => {
    if (payRequestConnection) {
      const payRequest = payRequestConnection.nodes.find(request => {
        return request?.owner.paymentId === paymentRequestId;
      });
      return payRequest;
    }
    return undefined;
  };
  const handlePaymentView = (record: Payment | undefined) => {
    if (record) {
      setActiveViewPaymentRecord(record);
      if (record.owner.paymentRequestId) {
        const request = findRelatedPaymentRequest(record.owner.paymentRequestId);
        dispatch(captureRelatedPaymentRequest(request));
      }
      setPaymentDetailsDialogOpen(true);
    }
  };

  const findDisputePayRequest = (paymentId: string | null | undefined) => {
    if (paymentId && payRequestConnection) {
      const payRequest = payRequestConnection.nodes.find(request => {
        return request?.owner.paymentId === paymentId;
      });
      if (!payRequest) {
        const altPayRequest = payRequestConnection.nodes.find(request => {
          return (
            request?.payments.find(payment => {
              return payment?.id === paymentId;
            }) !== undefined
          );
        });
        return altPayRequest;
      }
      return payRequest;
    }
    return undefined;
  };
  const handleDisputeView = (record: Dispute) => {
    if (record) {
      dispatch(captureSelectedDispute(record));
      const request = findDisputePayRequest(record.owner?.paymentId);
      dispatch(captureRelatedPaymentRequest(request));
      setDisputeDetailsDialogOpen(true);
    }
  };
  const handleDisputeViewClose = () => {
    setDisputeDetailsDialogOpen(false);
    dispatch(captureSelectedDispute(undefined));
    dispatch(captureRelatedPaymentRequest(undefined));
  };
  const handlePaymentRemind = (record: PaymentRequest | undefined) => {
    if (record) {
      const { referenceNumber, amount, id, invoiceId } = record;
      const email = record.communications.find(item => item?.communicationType === 'EMAIL')?.email;
      if (referenceNumber && amount && email && id && invoiceId) {
        dispatch(remindPaymentRequest(referenceNumber, amount, id, invoiceId, email));
        setRemindDisabled(true);
      }
    }
  };

  const handlePaymentRequestRefund = (record: PaymentRequest | undefined) => {
    if (record) {
      setDetailsDialogOpen(false);
      setActiveRefundPaymentRequestRecord(record);
      setRefundDialogOpen(true);
    }
  };
  const handleRefundSubmit = () => {
    setRefundDialogOpen(false);
    handlePaymentRequestsReload();
  };
  const handleRefundClose = () => {
    setRefundDialogOpen(false);
  };
  const handlePaymentRefund = (record: Payment | undefined) => {
    if (record) {
      setPaymentDetailsDialogOpen(false);
      setActiveRefundPaymentRecord(record);
      setPaymentRefundDialogOpen(true);
    }
  };
  const handlePaymentRefundSubmit = () => {
    setPaymentRefundDialogOpen(false);
    handlePaymentsReload();
  };
  const handlePaymentRefundClose = () => {
    setPaymentRefundDialogOpen(false);
  };

  const handleChargebackReview = (record: Dispute) => {
    if (record) {
      dispatch(captureSelectedDispute(record));
      const request = findDisputePayRequest(record.owner?.paymentId);
      dispatch(captureRelatedPaymentRequest(request));
      setChargebackDialogOpen(true);
    }
  };
  const handleChargebackClose = () => {
    setChargebackDialogOpen(false);
    dispatch(captureSelectedDispute(undefined));
    dispatch(captureRelatedPaymentRequest(undefined));
  };
  const handleChargebackConcede = () => {
    setChargebackDialogOpen(false);
    setConcedeDialogOpen(true);
  };
  const handleTransactionYearsClose = () => {
    setTransactionYearsDialogOpen(false);
  };
  const toggleYearsDialogOpen = () => {
    setTransactionYearsDialogOpen(!transactionYearsDialogOpen);
  };
  const handleConcedeBack = () => {
    setConcedeDialogOpen(false);
    setChargebackDialogOpen(true);
    dispatch(captureConcedeExplanation(''));
  };
  const handleConcede = () => {
    if (disputedRecord && disputedRecord.id) {
      dispatch(upsertConcedeDispute(disputedRecord?.id, concedeExplanation));
    }
  };
  const handleConcedeExplanationInput = (explanation: string) => {
    dispatch(captureConcedeExplanation(explanation));
  };
  const disputeClearConcedeStatus = () => {
    dispatch(clearConcedeStatus());
    setConcedeDialogOpen(false);
    dispatch(clearDisputeError());
    handleDisputesReload();
  };
  const handlePaymentDetailsFromRefund = (paymentRecord: Payment) => {
    handlePaymentRefundClose();
    handlePaymentView(paymentRecord);
  };
  const handlePaymentRequestDetailsFromPayment = (paymentRequest: PaymentRequest | undefined) => {
    handlePaymentDetailsClose();
    setActiveViewPaymentRequestRecord(paymentRequest);
    setDetailsDialogOpen(true);
  };

  const isPaymentRefundable = () => {
    const payment = selectedPayment;
    if (!payment) return false;
    let refunded = 0;
    payment?.refunds.map(refund => {
      if (refund?.status === RefundStatus.Completed || refund?.status === RefundStatus.Pending) {
        refunded += refund.amount || 0;
      }
    });
    if (refunded > 0) {
      dispatch(fetchIsPaymentRefunded(true));
      dispatch(fetchPaymentRefundedAmount(refunded));
    } else {
      dispatch(fetchIsPaymentRefunded(false));
      dispatch(fetchPaymentRefundedAmount(undefined));
    }
    return payment.status === PaymentStatus.Completed && !!payment.amount && refunded < payment.amount;
  };

  return (
    <Container maxWidth={false}>
      <Dialog open={refundDialogOpen} disableBackdropClick disableEscapeKeyDown fullWidth={true} maxWidth={'md'}>
        <IssueRefund
          close={handleRefundClose}
          paymentRecord={activeRefundPaymentRequestRecord}
          refundStatus={refundStatus}
          sendRefund={sendRefund}
          clearRefundStateStatus={clearRefundStateStatus}
          defaultCurrency={defaultCurrency}
          submit={handleRefundSubmit}
        />
      </Dialog>
      <Dialog open={paymentRefundDialogOpen} disableBackdropClick disableEscapeKeyDown fullWidth={true} maxWidth={'md'}>
        <IssueRefundPayment
          close={handlePaymentRefundClose}
          paymentRecord={activeRefundPaymentRecord}
          refundStatus={refundStatus}
          sendRefund={sendRefund}
          clearRefundStateStatus={clearRefundStateStatus}
          defaultCurrency={defaultCurrency}
          submit={handlePaymentRefundSubmit}
          openPaymentDetails={handlePaymentDetailsFromRefund}
          isPaymentRefunded={isPaymentRefunded}
          paymentRefundedAmount={paymentRefundedAmount}
        />
      </Dialog>
      {disputedRecord ? (
        <ChargebackReview
          open={chargebackDialogOpen}
          onClose={handleChargebackClose}
          concede={handleChargebackConcede}
          disputedRecord={disputedRecord}
          relatedPayment={disputeRelatedRequest}
        />
      ) : (
        <></>
      )}
      <Dialog
        open={concedeDialogOpen}
        disableBackdropClick
        disableEscapeKeyDown
        fullWidth={true}
        maxWidth={'sm'}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <ConcedeDispute
          explanation={concedeExplanation}
          handleExplanationChange={handleConcedeExplanationInput}
          back={handleConcedeBack}
          concede={handleConcede}
          postConcede={disputeClearConcedeStatus}
        />
      </Dialog>
      <PaymentRequestDetails
        open={detailsDialogOpen}
        onClose={handleDetailsClose}
        paymentRecord={activeViewPaymentRequestRecord}
        remind={handlePaymentRemind}
        refund={handlePaymentRequestRefund}
        defaultCurrency={defaultCurrency}
        remindPressed={remindDisabled}
      />
      <PaymentDetails
        open={paymentDetailsDialogOpen}
        onClose={handlePaymentDetailsClose}
        paymentRecord={activeViewPaymentRecord}
        refund={handlePaymentRefund}
        defaultCurrency={defaultCurrency}
        openPaymentRequestDetails={handlePaymentRequestDetailsFromPayment}
      />
      {disputedRecord && (
        <Dialog open={disputeDetailsDialogOpen} fullWidth={true} maxWidth={'sm'} onClose={handleDisputeViewClose}>
          <DisputeDetails disputedRecord={disputedRecord} close={handleDisputeViewClose} relatedPayment={disputeRelatedRequest} />
        </Dialog>
      )}
      <AdditionalVerificiations
        legalEntityCountry={countryCode}
        accountRequirements={accountRequirements}
        involvedUsers={involvedUsers}
        openDialog={dialogOpen}
        onClose={handleDialogClose}
        onSubmit={handleSubmit}
        entityName={entityName}
      />
      <AdditionVerificationIssuesBanner
        accountRequirements={accountRequirements}
        handleSettingsClick={handleSettingsClick}
        handleUploadClick={handleUploadClick}
        tenantAccount={tenantAccount}
      />
      {displayChallengeSuccessful && (
        <Box className={classes.challengeBanner} data-cy="challenge-banner">
          <Typography>Your challenge has been successfully submitted</Typography>
        </Box>
      )}
      <Grid container spacing={4} wrap={'wrap-reverse'} direction="row" justify="center" alignItems="stretch">
        <Grid container spacing={matches ? undefined : 4} item xs={12} md={4} xl={3} direction="column">
          {canCreatePaymentRequest && (
            <Grid item sm>
              <SendPaymentRequest
                clearDocument={clearDocumentState}
                defaultCurrency={defaultCurrency}
                requestPaymentUploadFile={requestPaymentUploadFile}
                requestPaymentUpsertPaymentRequest={requestPaymentUpsertPaymentRequest}
                requestPaymentClearPaymentRequestStatus={requestPaymentClearPaymentRequestStatus}
                invoiceStorageId={invoiceStorageId}
                paymentRequestStatus={paymentRequestStatus}
                paymentsDisabled={!paymentsEnabled}
                handleSettingsClick={handleSettingsClick}
                refreshTransactionData={handlePaymentRequestsReload}
                sendPaymentRequestError={sendPaymentRequestError}
                handlePaymentRequestFormValid={handlePaymentRequestFormValid}
                isPaymentRequestFormValid={isPaymentRequestFormValid}
                handleRecipientEmailValid={handleRecipientEmailValid}
                isRecipientEmailValid={isRecipientEmailValid}
                handleRecipientPhoneValid={handleRecipientPhoneValid}
                isRecipientPhoneValid={isRecipientPhoneValid}
                handleAmountValid={handleAmountValid}
                isAmountValid={isAmountValid}
                handleRefNumValid={handleRefNumValid}
                isRefNumValid={isRefNumValid}
              />
            </Grid>
          )}
          <Grid item>
            <TotalAccountBalance
              displayPayoutBanner={!paymentsEnabled}
              settingsClickHandler={handleSettingsClick}
              balances={currentBalances}
            />
          </Grid>
          <Grid item>
            <TransactionReports
              statements={tenantAccount?.statements}
              toggleYearsDialogOpen={toggleYearsDialogOpen}
              closeYears={handleTransactionYearsClose}
              yearsDialogOpen={transactionYearsDialogOpen}
            />
          </Grid>
        </Grid>
        <Grid item xs={12} md={8} xl={9}>
          <Paper className={classes.tabs}>
            <Tabs
              indicatorColor={'primary'}
              textColor={'primary'}
              variant="fullWidth"
              value={tabValue}
              onChange={handleTabChange}
              aria-label="home page tabs"
            >
              <Tab
                classes={{ selected: classes.selectedTab, root: classes.tabRoot }}
                label="ALL PAYMENTS"
                id="payments-tab"
                aria-controls="payments-tab-panel"
                data-cy="payment-tab"
              />
              <Tab
                classes={{ selected: classes.selectedTab, root: classes.tabRoot }}
                label="PAYMENT REQUESTS"
                id="payment-requests-tab"
                aria-controls="payment-requests-tab-panel"
                data-cy="payment-requests-tab"
              />
              <Tab
                classes={{ selected: classes.selectedTab, root: classes.tabRoot }}
                label={disputesLabel}
                id="disputes-tab"
                aria-controls="disputes-tab-panel"
                data-cy="payment-disputes-tab"
              />
            </Tabs>
            <TabPanel value={tabValue} index={0} data-cy="payments-panel">
              {/* TODO: Change field/sort/direction to be list specific */}
              <Toolbar variant="dense">
                <Grid alignItems="center" container spacing={1}>
                  <Grid container item xs={12} md={7} justify="flex-start">
                    <Button
                      startIcon={<RefreshIcon />}
                      size="medium"
                      variant={'text'}
                      aria-label={'refresh'}
                      color={'primary'}
                      onClick={handleActiveTabReload}
                      data-cy="refresh"
                    >
                      Refresh All
                    </Button>

                    {selectedPayment && (
                      <Button
                        startIcon={<InfoIcon />}
                        size="medium"
                        variant="text"
                        aria-label={'view details'}
                        color="primary"
                        onClick={() => handlePaymentView(selectedPayment)}
                        data-cy="view-details"
                      >
                        View Details
                      </Button>
                    )}

                    {isPaymentRefundable() && (
                      <Button
                        startIcon={<SvgIcon component={RefundIcon} />}
                        size="medium"
                        variant={'text'}
                        aria-label={'refund'}
                        color={'primary'}
                        onClick={() => handlePaymentRefund(selectedPayment)}
                        data-cy="refund"
                      >
                        Refund
                      </Button>
                    )}
                  </Grid>
                  <Grid container item xs={12} md={5} justify={matches ? 'flex-start' : 'flex-end'}>
                    <Grid item xs={12}>
                      <div className={isPaymentSearchOnFocus ? paymentSearchClass : classes.search}>
                        {!isPaymentSearchOnFocus && !isPaymentSearched && (
                          <div className={classes.searchIcon}>
                            <SearchIcon />
                          </div>
                        )}
                        <div className={classes.inputSearch}>
                          <InputBase
                            id="filled-adorment-weight"
                            disabled={tabValue !== 0}
                            value={paymentSearchString}
                            placeholder="Search by payment id"
                            onChange={event => handlePaymentSearchOnChange(event.target.value)}
                            onFocus={() => {
                              setIsPaymentSearchOnFocus(true);
                            }}
                            onBlur={() => handlePaymentSearchOnBlur()}
                            onKeyUp={event => {
                              if (event.keyCode === 13) handlePaymentsSearch();
                            }}
                            data-cy="payments-search"
                            classes={{
                              root: classes.inputRoot,
                              input: classes.inputInput,
                            }}
                          />
                        </div>
                        {isPaymentSearchOnFocus && !isPaymentSearched && (
                          <div className={classes.searchIcon}>
                            <Link
                              href="#"
                              onMouseDown={() => {
                                setIsPaymentSearchClicked(true);
                                setTimeout(() => handlePaymentsSearch(), 1000);
                              }}
                            >
                              <SearchIcon className={isValidPaymentSearchString ? '' : classes.searchIconError} />
                            </Link>
                          </div>
                        )}
                        {isPaymentSearched && (
                          <div className={classes.searchIcon}>
                            <Link href="#" onMouseDown={() => handlePaymentSearchOnCancel()}>
                              <CloseIcon className={isPaymentSearchOnFocus ? '' : classes.closeIcon} />
                            </Link>
                          </div>
                        )}
                      </div>
                    </Grid>
                    {!isValidPaymentSearchString && (
                      <Grid item xs={12} className={classes.errorContent}>
                        <Typography color="error">Your search must have atleast 3 characters.</Typography>
                      </Grid>
                    )}
                  </Grid>
                  {searchError && (
                    <Grid item xs={12}>
                      <Typography color="error">An error has occurred with the search</Typography>
                    </Grid>
                  )}
                </Grid>
              </Toolbar>
              {paymentConnection && (
                <PaymentsList
                  loadPage={loadPaymentsPage}
                  handleViewPayment={handlePaymentView}
                  handleRefundPayment={handlePaymentRefund}
                  setSelectedRecord={setSelectedPayment}
                  selectedRecord={selectedPayment}
                  defaultCurrency={defaultCurrency}
                  paymentConnection={paymentConnection}
                  payments={payments}
                  direction={paymentDirection}
                  field={paymentField}
                  handleSort={handlePaymentSort}
                  isLoadingPayments={isLoadingPayments}
                />
              )}
            </TabPanel>
            <TabPanel value={tabValue} index={1} data-cy="payment-requests-panel">
              {/* TODO: Change field/sort/direction to be list specific */}
              <Toolbar variant="dense">
                <Grid alignItems="center" container spacing={1}>
                  <Grid container item xs={12} md={7} justify="flex-start">
                    <Button
                      startIcon={<RefreshIcon />}
                      size="medium"
                      variant={'text'}
                      aria-label={'refresh'}
                      color={'primary'}
                      onClick={handleActiveTabReload}
                      data-cy="refresh"
                    >
                      Refresh All
                    </Button>

                    {selectedPaymentRequest && (
                      <Button
                        startIcon={<InfoIcon />}
                        size="medium"
                        variant="text"
                        aria-label={'view details'}
                        color="primary"
                        onClick={() => handlePaymentRequestView(selectedPaymentRequest)}
                        data-cy="view-details"
                      >
                        View Details
                      </Button>
                    )}

                    {tabValue !== 1 ||
                      ((selectedPaymentRequest?.status === PaymentRequestStatus.Completed ||
                        selectedPaymentRequest?.status === PaymentRequestStatus.PartiallyRefunded ||
                        selectedPaymentRequest?.status === PaymentRequestStatus.RefundFailed) && (
                        <Button
                          startIcon={<SvgIcon component={RefundIcon} />}
                          size="medium"
                          variant={'text'}
                          aria-label={'refund'}
                          color={'primary'}
                          onClick={() => handlePaymentRequestRefund(selectedPaymentRequest)}
                          data-cy="refund"
                        >
                          Refund
                        </Button>
                      ))}

                    {selectedPaymentRequest &&
                      (selectedPaymentRequest?.status === PaymentRequestStatus.Unpaid ||
                        selectedPaymentRequest?.status === PaymentRequestStatus.Failed ||
                        selectedPaymentRequest?.status === PaymentRequestStatus.Canceled) && (
                        <Button
                          startIcon={<NotificationsIcon />}
                          size="medium"
                          variant="text"
                          aria-label="remind"
                          color="primary"
                          onClick={() => handlePaymentRemind(selectedPaymentRequest)}
                          data-cy="remind"
                          disabled={remindDisabled}
                        >
                          Remind
                        </Button>
                      )}
                  </Grid>
                  <Grid container item xs={12} md={5} justify={matches ? 'flex-start' : 'flex-end'}>
                    <Grid item xs={12}>
                      <div className={isPaymentRequestSearchOnFocus ? paymentRequestSearchClass : classes.search}>
                        {!isPaymentRequestSearchOnFocus && !isPaymentRequestSearched && (
                          <div className={classes.searchIcon}>
                            <SearchIcon />
                          </div>
                        )}
                        <div className={classes.inputSearch}>
                          <InputBase
                            id="filled-adorment-weight"
                            disabled={tabValue !== 1}
                            value={paymentRequestSearchString}
                            placeholder="Search by reference #, email, or phone number"
                            onChange={event => handlePaymentRequestSearchOnChange(event.target.value)}
                            onFocus={() => {
                              setIsPaymentRequestSearchOnFocus(true);
                            }}
                            onBlur={() => handlePaymentRequestSearchOnBlur()}
                            onKeyUp={event => {
                              if (event.keyCode === 13) handleSearch();
                            }}
                            classes={{
                              root: classes.inputRoot,
                              input: classes.inputInput,
                            }}
                            data-cy="search"
                          />
                        </div>
                        {isPaymentRequestSearchOnFocus && !isPaymentRequestSearched && (
                          <div className={classes.searchIcon}>
                            <Link
                              href="#"
                              onMouseDown={() => {
                                setIsPaymentRequestSearchClicked(true);
                                setTimeout(() => handleSearch(), 1000);
                              }}
                            >
                              <SearchIcon className={isValidPaymentRequestSearchString ? '' : classes.searchIconError} />
                            </Link>
                          </div>
                        )}
                        {isPaymentRequestSearched && (
                          <div className={classes.searchIcon}>
                            <Link href="#" onMouseDown={() => handlePaymentRequestSearchOnCancel()}>
                              <CloseIcon className={isPaymentRequestSearchOnFocus ? '' : classes.closeIcon} />
                            </Link>
                          </div>
                        )}
                      </div>
                    </Grid>
                    {!isValidPaymentRequestSearchString && (
                      <Grid item xs={12} className={classes.errorContent}>
                        <Typography color="error">Your search must have atleast 3 characters.</Typography>
                      </Grid>
                    )}
                  </Grid>
                  {searchError && (
                    <Grid item xs={12}>
                      <Typography color="error">An error has occurred with the search</Typography>
                    </Grid>
                  )}
                </Grid>
              </Toolbar>
              {payRequestConnection && (
                <PaymentRequestList
                  loadPage={loadPaymentRequestsPage}
                  handleViewPayment={handlePaymentRequestView}
                  handleRefundPayment={handlePaymentRequestRefund}
                  setSelectedRecord={setSelectedPaymentRequest}
                  selectedRecord={selectedPaymentRequest}
                  defaultCurrency={defaultCurrency}
                  paymentRequestConnection={payRequestConnection}
                  paymentRequests={paymentRequests}
                  direction={paymentRequestDirection}
                  field={paymentRequestField}
                  handleSort={handlePaymentRequestSort}
                  isLoadingPaymentRequests={isLoadingPaymentRequests}
                />
              )}
            </TabPanel>
            <TabPanel value={tabValue} index={2} data-cy="payment-disputes-panel">
              <Toolbar variant="dense">
                <Grid item xs={matches ? 12 : undefined} sm={matches ? 4 : undefined}>
                  <Button
                    startIcon={<RefreshIcon />}
                    size="medium"
                    variant={'text'}
                    aria-label={'refresh'}
                    color={'primary'}
                    onClick={handleActiveTabReload}
                    data-cy="refresh"
                  >
                    Refresh All
                  </Button>
                </Grid>
              </Toolbar>
              {/* TODO: Change field/sort/direction to be list specific */}
              {disputeConnection && (
                <DisputeList
                  loadPage={loadDisputesPage}
                  handleChargebackReview={handleChargebackReview}
                  handleViewDispute={handleDisputeView}
                  setSelectedRecord={setSelectedDispute}
                  selectedRecord={selectedDispute}
                  defaultCurrency={defaultCurrency}
                  disputeConnection={disputeConnection}
                  disputes={disputes}
                  direction={disputeDirection}
                  field={disputeField}
                  handleSort={handleDisputeSort}
                  isLoadingDisputes={isLoadingDisputes}
                />
              )}
            </TabPanel>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Home;
